import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dropdown', 'options', 'loader', 'saveLink'];
  static values = { indexUrl: String };

  #message = '';
  #loaded = false;
  #outsideClickHandler = null;

  connect() {
    this.#outsideClickHandler = (event) => {
      if (!this.dropdownTarget.contains(event.target)) {
        this.#close();
      }
    };
    document.addEventListener('click', this.#outsideClickHandler, true);
  }

  disconnect() {
    document.removeEventListener('click', this.#outsideClickHandler, true);
  }

  #close() {
    this.optionsTarget.classList.remove('block');
    this.optionsTarget.classList.add('hidden');
    this.dropdownTarget.classList.remove('load-preset--active');
  }

  toggle(event) {
    event.preventDefault();
    const isOpen = this.optionsTarget.classList.contains('block');

    if (isOpen) {
      this.#close();
    } else {
      this.optionsTarget.classList.remove('hidden');
      this.optionsTarget.classList.add('block');
      this.dropdownTarget.classList.add('load-preset--active');

      if (!this.#loaded && this.hasLoaderTarget) {
        this.loaderTarget.src = this.indexUrlValue;
        this.#loaded = true;
      }
    }
  }

  close() {
    this.#close();
  }

  save(event) {
    if (!this.#message.trim()) {
      event.preventDefault();
      return;
    }

    const message = this.#message;
    const handler = (e) => {
      document.removeEventListener('turbo:before-stream-render', handler);
      const template = e.target.templateElement?.content;
      const textarea = template?.querySelector('textarea[name="preset[details]"]');
      if (textarea) {
        textarea.textContent = message;
      }
    };
    document.addEventListener('turbo:before-stream-render', handler, { once: true });
  }

  updateMessage({ detail: { message } }) {
    this.#message = message;

    if (this.hasSaveLinkTarget) {
      this.saveLinkTarget.classList.toggle('save-preset-link--disabled', !message.trim());
    }
  }
}
